import { FirestoreDataConverter, DocumentData, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export const EMAIL_AUTH_PATH = "email_authentication";

export type EmailAuthType = {
  id: string;
  email: string;
  isVerified: boolean;
  createTime: number;
  updateTime: number;
};

export const emailAuthConverter: FirestoreDataConverter<EmailAuthType> = {
  toFirestore(obj: EmailAuthType): DocumentData {
    return {
      id: obj.id,
      email: obj.email,
      isVerified: obj.isVerified,
      createTime: Math.round(obj.createTime || 0),
      updateTime: Math.round(obj.updateTime || 0),
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): EmailAuthType {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      email: data.email,
      isVerified: data.isVerified,
      createTime: Math.round(data.createTime || 0),
      updateTime: Math.round(data.updateTime || 0),
    };
  },
};
